import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { sanitize } from '@plugins/shared/utils/sanitize';

@Pipe({
  name: 'dompurify',
  standalone: true,
})
export class DompurifyPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  public transform(value: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(sanitize(value));
  }
}
